module.exports = __webpack_public_path__ + "static/equipe-a-bea34e202571871c7505cd9c1a6dd6b0.jpg";